
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf-lessons/[...param]",
      function () {
        return require("private-next-pages/golf-lessons/[...param]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf-lessons/[...param]"])
      });
    }
  